import { useMemo } from 'react'

import { F0TableOfContent, type TOCItem } from '@factorialco/f0-react/dist/experimental'
import type {
  ContractsValueObjectsAdditionalCompensationRecurrenceEnum,
  IncentivesCompensationPlanPeriodFragment,
} from 'generated/resources/graphql'
import { sortBy } from 'lodash'
import i18n from 'modules/core/lib/i18n'
import { periodLabel } from 'modules/incentives/lib/period'

interface SideContentProps {
  periods: IncentivesCompensationPlanPeriodFragment[]
  recurrence: ContractsValueObjectsAdditionalCompensationRecurrenceEnum
  currentPeriodId?: string
  selectedPeriodId: string
  onPeriodSelect: (periodId: string) => void
}

export function SideContent({
  periods,
  recurrence,
  selectedPeriodId,
  currentPeriodId,
  onPeriodSelect,
}: SideContentProps) {
  const items: TOCItem[] = useMemo(
    () =>
      sortBy(periods, (p) => p.startsOn).map((period) => ({
        id: period.id,
        label:
          periodLabel(recurrence, period) +
          (period.id === currentPeriodId ? ` (${i18n.t('incentives.periods.current')})` : ''),
        onClick: (id: string) => {
          onPeriodSelect(id)
        },
      })),
    [periods, recurrence, currentPeriodId, onPeriodSelect]
  )

  return (
    <F0TableOfContent
      title={i18n.t('incentives.periods.title')}
      items={items}
      activeItem={selectedPeriodId}
    />
  )
}
